import { useTranslation } from "react-i18next";
import { Control } from "react-hook-form";
import { FormGroup } from "@carbon/react";
import TextField from "../../../components/carbon/Form/TextField";
import { RegisterFormValues } from "../types";

export interface CredentialsSectionProps {
  control: Control<RegisterFormValues>;
}

/**
 * Credentials field group: password / confirmPassword, plus the password-requirements
 * checklist. The schema enforces min-12 + complexity (Task 2 — the backend enforces the
 * same); the list restates those rules for the user, unchanged from the pre-Carbon form.
 */
const CredentialsSection = ({ control }: CredentialsSectionProps) => {
  const { t } = useTranslation();

  return (
    <FormGroup legendText={t("register.form.password")}>
      <div className="register__grid">
        <TextField
          name="password"
          type="password"
          label={t("register.form.password")}
          control={control}
          required
        />
        <TextField
          name="confirmPassword"
          type="password"
          label={t("register.form.confirmPassword")}
          control={control}
          required
        />
      </div>
      <div className="register__requirements">
        <p>{t("changePassword.title")}</p>
        <ul>
          <li>{t("changePassword.characters")}</li>
          <li>{t("changePassword.uppercase")}</li>
          <li>{t("changePassword.lowercase")}</li>
          <li>{t("changePassword.number")}</li>
          <li>{t("changePassword.special")}</li>
        </ul>
      </div>
    </FormGroup>
  );
};

export default CredentialsSection;
